export default __webpack_public_path__ + "static/media/dta_1.228c1f46.png";